<template>
	<div style="height:100%">
		<div class="selectionBar">
			<div class="flex flex-ai-c flex-jc-sb flex-wrap">
				<label>股东分红：<i class="el-icon-warning" style="color: #409EFF" @click="dialog2=true"></i></label>
				<el-input placeholder="股东名称" v-model="searchValue" size="small" class="input-with-select" @change="curr=1;getList()" style="width:300px;">
					<el-button slot="append" icon="el-icon-search" ></el-button>
				</el-input>
				<el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="edit()">添加</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 140px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
				<el-table-column prop="name" label="股东名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="ratio" label="分红比例 %" show-overflow-tooltip></el-table-column>
				<el-table-column prop="level_name" label="股东级别" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time_format" label="创建时间" show-overflow-tooltip></el-table-column>
				<el-table-column fixed="right" label="操作" width="120" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button type="primary" icon="el-icon-edit" size="small" @click="edit(scope.row)"></el-button>
							<el-button type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>

		<!-- 新建框 -->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="600px">
			<el-form ref="formAuth" :rules="formRules" :model="formData" label-position="top" size="small" class="alertForm">
				<el-form-item class="hide"></el-form-item>
				<el-form-item label="股东名称" prop="name" style="width:100%">
					<el-input v-model="formData.name" autocomplete="off" placeholder="股东名称"></el-input>
				</el-form-item>
				<el-form-item class="hide"></el-form-item>
				<el-form-item label="分红比例" prop="ratio" style="width:100%">
					<el-input v-model.number="formData.ratio" autocomplete="off" placeholder="分红比例">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item class="hide"></el-form-item>
				<el-form-item label="股东级别" prop="level_id" style="width:100%">
					<el-select v-model="formData.level_id" clearable placeholder="请选择股东级别">
						<el-option v-for="(val,key) in gdlist" :key="key" :label="val" :value="key"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submit()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="股东分红设置" :visible.sync="dialog2" :modal-append-to-body="false" :close-on-click-modal="false" width="400px">
			<div>
				自己设置股东分红的利率
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title: '添加股东',
				dialogFormVisible: false,
				dialog2: false,
				formLabelWidth: '80px',
				formData: {},
				formRules: {
					name: [{
						required: true,
						message: '请输入股东名称',
						trigger: 'blur'
					}],
					ratio: [{
						required: true,
						message: '请输入分红比例',
						trigger: 'blur'
					}, {
						pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
						message: '请输入数字（保留两位小数）',
						trigger: 'change'
					}],
					level_id: [{
						required: true,
						message: '请选择股东级别',
						trigger: 'blur'
					}],
				},

				ispwd: true,
				list: [],
				searchValue: '',
				gdlist: [],

				curr: 1, //页码
				row: 20, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
			}
		},
		mounted() {
			this.getList();
			// 股东级别列表
			this.http.post('/admin/shareholder/getLevelList').then(res => {
				this.gdlist = res.level_list;
			});
		},
		methods: {

			getList() {
				this.http.post('/admin/shareholder/getList', {
					curr: this.curr,
					row: this.row,
					wd: this.searchValue
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},
			edit(row) {
				if (row) {
					this.ispwd = false;
					this.formData = JSON.parse(JSON.stringify(row));
					this.formData.level_id = `${this.formData.level_id}`
					this.title = '编辑股东';
				} else {
					this.ispwd = true;
					this.formData = {};
					this.title = '添加股东';
				}
				this.dialogFormVisible = true;
			},
			del(row) {
				this.$confirm(`确定删除吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var url = '/admin/shareholder/delete';
					this.http.post(url, {
						id: row.id,
					}).then(() => {
						this.getList();
						this.$message({
							type: 'success',
							message: '已删除!'
						});
					})
				})
			},
			submit() {
				// 验证
				this.$refs['formAuth'].validate((valid) => {
					if (valid) {
						var apiUrl = "/admin/shareholder/save";
						this.http.post(apiUrl, this.formData).then(() => {
							this.dialogFormVisible = false;
							this.$message({
								message: '提交成功',
								type: 'success'
							});
							this.getList();
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			},
		}
	}
</script>

<style lang="css" scoped>
</style>
